import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { IconButton, Box, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Typewriter } from "react-simple-typewriter";

const images = [
  "https://static.vecteezy.com/system/resources/thumbnails/045/826/349/small_2x/the-dark-stage-shows-dark-background-an-empty-dark-scene-neon-light-and-spotlights-the-concrete-floor-and-studio-room-with-smoke-float-up-the-interior-texture-high-quality-photo.jpg",
  "https://png.pngtree.com/thumb_back/fh260/background/20201223/pngtree-yellow-simple-fresh-watercolor-education-background-image_512112.jpg",
  "https://t4.ftcdn.net/jpg/02/99/84/89/360_F_299848927_S0EwX0P6HWGigW6qZWFIBaczKMQuq5D9.jpg",
];

const inspirationSources = [
  "NEP 2020",
  "NCFSE-2023",
  "CSTA and ISTA Standards",
  "Principles of Competency-based Education",
  "Sustainable Development Goals",
  "The OECD Learning Compass 2030",
];

const CarouselDisplay = () => {
  const [currentText, ] = useState(inspirationSources);

  return (
    <Box sx={{ position: "relative", width: "100vw", height: "70vh", mt: 10 }}>
      <Swiper
        navigation={{
          nextEl: ".next-button",
          prevEl: ".prev-button",
        }}
        modules={[Navigation]}
        loop
        className="mySwiper"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                width: "100%",
                height: "70vh",
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              <Box sx={{ textAlign: 'center', py: 10 }}>
                <Typography variant="h5" color='#ffffff7a'> Our Core Sources of Inspirations </Typography>
              </Box>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <IconButton
        className="prev-button"
        style={{
          position: "absolute",
          top: "50%",
          left: "20px",
          transform: "translateY(-50%)",
          color: "white",
          zIndex: 10,
        }}
      >
        <ArrowBackIosIcon />
      </IconButton>

      <IconButton
        className="next-button"
        style={{
          position: "absolute",
          top: "50%",
          right: "20px",
          transform: "translateY(-50%)",
          color: "white",
          zIndex: 10,
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          zIndex: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography variant="h3" color='white'>
          <Typewriter
            words={currentText}
            loop
            cursor
            cursorStyle='|'
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={3000}
          />
        </Typography>
      </Box>
    </Box>
  );
};

export default CarouselDisplay;